import { TyreChange } from './tyre-change'
import { APIResponse } from '../../helpers'

export type TyreChangeForVehicleResponse = APIResponse<TyreChange>

export const getLastTyreChange = (vehicleUUID: string) => ({
  method: 'GET',
  url: `/modules/tyre-changes/for-vehicle/${vehicleUUID}`
})
